// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__vNp1N","topBar":"style__topBar__RHJ2I","label":"style__label__2+ELe","problemName":"style__problemName__yTpZv"};